var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.505,
    height: 62.505,
    viewBox: "0 0 62.505 62.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2083",
    "data-name": "Rectangle 2083",
    width: 31.577,
    height: 31.732
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2598",
    "data-name": "Groupe 2598",
    transform: "translate(-1442.5 -730.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2463",
    "data-name": "Groupe 2463",
    transform: "translate(659.926 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M61.5,30.753A30.752,30.752,0,1,1,30.753,0,30.752,30.752,0,0,1,61.5,30.753",
    transform: "translate(783.074 710.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2473",
    "data-name": "Groupe 2473",
    transform: "translate(798.038 723.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2472",
    "data-name": "Groupe 2472",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2939",
    "data-name": "Trac\\xE9 2939",
    d: "M.619,10.68H6.888V31.732H.619ZM3.715,0a3.792,3.792,0,0,1,0,7.585A3.733,3.733,0,0,1,0,3.792,3.733,3.733,0,0,1,3.715,0M10.6,10.68h6.192v2.941a7.164,7.164,0,0,1,5.959-3.173h1.7a7.151,7.151,0,0,1,7.12,7.12V31.732H25.385V20.355a4.116,4.116,0,0,0-4.1-4.257,4.447,4.447,0,0,0-4.489,4.257V31.732H10.6Z",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.3ea2e928c23d1f39a83ff47aaca32bda.svg";
export { ForwardRef as ReactComponent };